<template>
    <div class="layout-title cf">

        <div class="layout-title-box fl"></div>

        <div class="fl">{{ title }}</div>

    </div>
</template>

<script>
import mixin from "./mixin/mixin";
export default {
    name: "layout-title",
    mixins: [mixin],
    props: {
        title: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped src="./style.css"></style>
